import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import { BreadCrumb } from './breadcrumb.interface'

@Component({
  selector: 'dmmp-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit, OnChanges {
  public breadcrumbs: BreadCrumb[] = [{ label: 'Home', url: '' }]
  public showBreadcrumb: boolean
  public isUniversity: boolean
  public isArticles: boolean
  @Input() data: any
  @Input() identifier: string
  @Input() breadcrumbElements: any
  @Output() page = new EventEmitter()

  ngOnInit(): void {
    this.makeBreadcrumb(this.breadcrumbElements)
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.makeBreadcrumb(this.breadcrumbElements)
  }

  makeBreadcrumb(breadcrumbElements): void {
    this.breadcrumbs = [{ label: 'Home', url: '' }]
    breadcrumbElements?.forEach((element) => {
      if (element.label && element.path) {
        this.breadcrumbs.push({
          label: element.label,
          url: element.path,
        })
      }
    })
    this.breadcrumbs?.length > 1
      ? (this.showBreadcrumb = true)
      : (this.showBreadcrumb = false)
    this.breadcrumbs?.find((element) => {
      element?.url?.includes('universities')
        ? (this.isUniversity = true)
        : (this.isUniversity = false)
      element?.url?.includes('articles')
        ? (this.isUniversity = true)
        : (this.isUniversity = false)
    })
  }
}
